export default {
  // Navigation
  nav_home: "Accueil",
  nav_about: "À Propos",
  nav_programs: "Programmes",
  nav_admissions: "Admissions",
  nav_research: "Recherche",
  nav_partnerships: "Partenariats",
  nav_campus: "Campus",
  nav_news: "Actualités",
  nav_contact: "Contact",
  nav_apply: "Candidater",
  nav_lang_fr: "FR",
  nav_lang_en: "EN",

  // Hero
  // Home Hero Card
  hero_card_intro: "Située au Palais des Congrès de Yaoundé, ESTAD forme les leaders de demain à travers quatre piliers d'excellence. Rejoignez l'université de l'innovation au cœur de l'Afrique centrale.",
  hero_card_address: "Palais des Congrès, Partie Basse",
  hero_card_city: "Yaoundé, Cameroun",
  hero_card_email: "secretariat@estad-university.com",
  hero_card_phone: "(+237) 682 29 12 12",

  // Programs Hero Card
  programs_hero_card_intro: "ESTAD propose quatre piliers d'excellence — Télécoms, Informatique, Communication Numérique et Énergies — structurés autour du parcours LMD et d'un coaching entrepreneurial en 7 étapes.",
  programs_hero_card_pillar1: "Télécoms & Informatique",
  programs_hero_card_pillar2: "Communication Numérique",
  programs_hero_card_pillar3: "Ingénierie Énergétique",
  programs_hero_card_pillar4: "Coaching Entrepreneurial",
  programs_hero_card_cta: "Explorer les Programmes",

  // Research Hero Card
  research_hero_card_intro: "ESTAD abrite l'un des 15 centres CATI enregistrés auprès de l'OMPI au Cameroun. Notre approche RAFT transforme chaque cours en opportunité d'innovation.",
  research_hero_card_cati: "Centre CATI OMPI — 1 sur 15 au Cameroun",
  research_hero_card_areas: "6 Axes de Recherche Actifs",
  research_hero_card_partners: "Partenaires de Recherche Mondiaux",
  research_hero_card_cta: "Découvrir nos Laboratoires",

  // Partnerships Hero Card
  partnerships_hero_card_intro: "Un réseau global s'étendant du Cameroun à l'Europe, au Canada, en Inde et en Asie. ESTAD détient l'exclusivité BeingCert USA pour 11 pays CEMAC.",
  partnerships_hero_card_count: "12+ Partenaires Institutionnels",
  partnerships_hero_card_beingcert: "BeingCert USA — Exclusivité CEMAC",
  partnerships_hero_card_global: "Europe · Canada · Inde · Asie",
  partnerships_hero_card_cta: "Voir Tous les Partenaires",

  // Admissions Hero Card
  admissions_hero_card_intro: "Candidatures ouvertes en Janvier 2026. Tous profils motivés sont les bienvenus — Baccalauréat ou GCE A/L avec 3 matières. Pas de limite d'âge.",
  admissions_hero_card_open: "Ouverture Candidatures",
  admissions_hero_card_deadline: "Date Limite",
  admissions_hero_card_start: "Rentrée Académique",
  admissions_hero_card_requirement: "Baccalauréat ou GCE A/L",
  admissions_hero_card_cta: "Candidater en Ligne",

  // Contact Hero Card
  contact_hero_card_intro: "Nous sommes là pour vous aider. Contactez-nous pour les admissions, les partenariats ou les demandes générales. Notre équipe répond sous 24 heures.",
  contact_hero_card_address_label: "Adresse",
  contact_hero_card_address_value: "Palais des Congrès, Partie Basse, Yaoundé",
  contact_hero_card_phone_label: "Téléphone",
  contact_hero_card_hours_label: "Heures de Bureau",
  contact_hero_card_hours_value: "Lun — Ven : 8h00 — 17h00",
  contact_hero_card_cta: "Itinéraire",

  // Campus Hero Card
  campus_hero_card_intro: "Un campus premium au Palais des Congrès de Yaoundé. Environnement bilingue, associations étudiantes et communauté spirituelle inclusive.",
  campus_hero_card_location: "Palais des Congrès, Partie Basse",
  campus_hero_card_bilingual: "Campus Bilingue Français-Anglais",
  campus_hero_card_associations: "BEDIR & ANIPES — Corps Étudiant",
  campus_hero_card_cta: "Visite Virtuelle",

  hero_title_line1: "L'Université",
  hero_title_line2: "de Demain",
  hero_title_line3: "Construisons l'Avenir Ensemble",
  hero_description_short: "ESTAD University Institute — Votre partenaire pour une éducation d'excellence au cœur de l'Afrique.",
  hero_tagline: "Inspire, Innovate, For a Better World!",
  hero_cta_apply: "Candidater Maintenant",
  hero_cta_discover: "Découvrir nos Programmes",
  hero_cta_discover_piliers: "Découvrir nos piliers",

  // Stats
  stats_founded_label: "Fondée",
  stats_founded_value: "2020",
  stats_programs_label: "Programmes",
  stats_programs_value: "6",
  stats_partners_label: "Partenaires",
  stats_partners_value: "10+",
  stats_cati_label: "CATI",
  stats_cati_value: "OMPI-Certifié",

  // Why ESTAD
  why_title: "Pourquoi ESTAD ?",
  why_subtitle: "Une expérience académique unique au cœur de l'innovation camerounaise",
  why_card_tech_title: "Apprentissage Assisté par la Technologie",
  why_card_tech_desc: "Plateformes digitales, cours hybrides et laboratoires modernes pour une pédagogie de pointe.",
  why_card_entrepreneurship_title: "Entrepreneuriat Universitaire",
  why_card_entrepreneurship_desc: "Incubation d'entreprises, coaching entrepreneur et accès au financement pour les projets étudiants.",
  why_card_diplomas_title: "Diplômes Nationaux & Internationaux",
  why_card_diplomas_desc: "Formations certifiantes reconnues au Cameroun et à l'international grâce à nos partenariats stratégiques.",
  why_card_innovation_title: "Centre d'Innovation — CATI",
  why_card_innovation_desc: "Un des 15 centres OMPI au Cameroun. Propriété intellectuelle, recherche appliquée et transfert technologique.",

  // News / Events
  news_title: "Actualités & Événements",
  news_subtitle: "Restez informé de la vie académique et scientifique d'ESTAD",
  news_read_more: "Lire la suite",

  news_view_all: "Voir tous les événements",

  // Newsletter
  newsletter_title: "Rejoignez la Communauté ESTAD",
  newsletter_subtitle: "Recevez nos actualités, appels à candidature et événements directement dans votre boîte mail.",
  newsletter_placeholder: "Votre adresse e-mail",
  newsletter_button: "S'inscrire",
  newsletter_success: "Merci pour votre inscription !",
  newsletter_error: "Une erreur est survenue. Veuillez réessayer.",

  about_hero_badge: "Depuis 2020",
  about_hero_cta_leadership: "Notre Direction",
  about_hero_cta_vision: "Vision & Mission",
  about_hero_inauguration: "Inaugurée par le Ministre de l'Enseignement Supérieur",
  about_hero_inauguration_date: "Fondée le 18 Novembre 2020, en pleine pandémie COVID-19",
  about_hero_minesup_label: "Autorisation MINESUP",
  about_hero_minesup_number: "N° 20-06511 — Fondée le 18 Novembre 2020",

  about_leadership_badge: "Direction",
  about_dg_founder_note: "Fondateur 2019 — Promo 94 Mines-Télécoms",

  about_name_badge: "Notre Identité",
  about_name_full: "École Supérieure des Techniques Avancées pour le Développement — un nom qui incarne notre ambition : former des professionnels de haut niveau aux technologies de pointe au service du développement durable.",

  about_supervisors_badge: "Supervision",
  about_supervisor_polytech_desc: "École Polytechnique de Douala",
  about_supervisor_ube_desc: "Université publique du Cameroun",

  // About Page
  about_title: "À Propos d'ESTAD",
  about_history_title: "Notre Histoire",
  about_history_text1: "L'École Supérieure des Techniques Avancées pour le Développement (ESTAD) a été fondée le 18 novembre 2020, en pleine pandémie de COVID-19, dans un contexte où l'éducation digitale et la résilience économique sont devenues indispensables.",
  about_history_text2: "Autorisée par le MINESUP sous le numéro 20-06511, ESTAD représente une nouvelle génération d'établissements d'enseignement supérieur au Cameroun, axés sur l'innovation, l'entrepreneuriat et la technologie.",
  about_name_title: "Notre Nom",
  about_name_e: "École",
  about_name_s: "Supérieure",
  about_name_t: "Techniques",
  about_name_a: "Avancées",
  about_name_d: "Développement",
  about_vision_title: "Notre Vision",
  about_vision_text: "Devenir une université d'excellence mondialement reconnue, pionnière en entrepreneuriat, innovation et impact sociétal.",
  about_mission_title: "Notre Mission",
  about_mission_text: "Enseigner, apprendre, en tout temps, en tout lieu et quelque soit l'âge, pour construire un monde meilleur.",
  about_leadership_title: "Mot du Leadership",
  about_pca_title: "PCA / Président",
  about_pca_name: "Prof. Etienne Mfoumou, PhD",
  about_pca_message: "ESTAD est née d'une vision audacieuse : créer un écosystème académique où la recherche, l'innovation et l'entrepreneuriat convergent pour transformer le Cameroun et l'Afrique.",
  about_dg_title: "Directeur Général",
  about_dg_name: "MEZOM MELOUTA",
  about_dg_role: "Ingénieur TICE, Mines-Télécoms-Nord Europe Promo 94, fondateur 2019",
  about_dg_message: "Notre ambition est de former des étudiants-entrepreneurs capables de créer de la valeur technologique et économique, en s'appuyant sur un réseau international de partenaires académiques et industriels.",
  about_supervisors_title: "Superviseurs Académiques",
  about_supervisor_polytech: "Polytech Douala",
  about_supervisor_ube: "Université de Bertoua (UBe)",
  about_lmd_title: "Système LMD",
  about_lmd_desc: "Licence-Master-Doctorat : L1/L2 tronc commun, DUT, Licence, Master 1 & 2, Doctorat (co-tutelle internationale).",
  about_tice_highlight: "Première école privée au Cameroun utilisant les TICE comme moyen pédagogique principal",
  about_philosophy_title: "Notre Philosophie",
  about_philosophy_quote: "Né à l'Image de Dieu, vous êtes CO-CRÉATEUR",
  about_philosophy_pillars: "Foi + Rationalité + Courage + Stratégie",
  about_loi_title: "Université-Entreprise",
  about_loi_desc: "Loi 2023/007 : cadre légal camerounais de collaboration université-entreprise pour l'innovation et l'employabilité.",
  about_beingcert_title: "BeingCert USA — Exclusivité CEMAC",
  about_beingcert_desc: "ESTAD détient l'exclusivité BeingCert USA pour 11 pays CEMAC en Intelligence Artificielle et Cybersécurité.",

  about_lmd_badge: "Parcours Académique",

  about_lmd_step_1_desc: "Tronc Commun",
  about_lmd_step_2_desc: "Diplôme Universitaire",
  about_lmd_step_3_desc: "Bachelor",
  about_lmd_step_4_desc: "Master Professionnel",
  about_lmd_step_5_desc: "Co-tutelle Internationale",

  // Programs Page
  programs_title: "Nos Programmes",
  programs_subtitle: "Quatre piliers d'excellence pour former les leaders de demain",
  programs_pillar_t: "Télécoms (T)",
  programs_pillar_t_desc: "Ingénierie des télécommunications, réseaux mobiles, fibre optique, 5G et systèmes embarqués.",
  programs_pillar_i: "Informatique (I)",
  programs_pillar_i_desc: "Informatique, développement logiciel, intelligence artificielle, cybersécurité et data science.",
  programs_pillar_c: "Communication & Arts Numériques (C)",
  programs_pillar_c_desc: "Médias digitaux, design interactif, production audiovisuelle, marketing digital et journalisme numérique.",
  programs_pillar_e: "Énergies (E)",
  programs_pillar_e_desc: "Ingénierie énergétique, énergies renouvelables, smart grids et transition énergétique.",
  programs_pathway_title: "Parcours Académique",
  programs_pathway_initial: "Formation Initiale",
  programs_pathway_initial_steps: "Tronc Commun (4 sem) → DUT/BTS/DU → Licence (2 sem) → Master 1&2 (4 sem) → Doctorat (8 sem, co-tutelle)",
  programs_pathway_continuing: "Formation Continue",
  programs_pathway_continuing_desc: "Parcours personnalisé, validation des acquis (VAE), certifications professionnelles de 1 à 3 mois.",
  programs_journey_title: "Voyage de l'Étudiant",
  programs_journey_from: "Étudiant-Entrepreneur",
  programs_journey_to: "Entrepreneur-Industriel",
  programs_7step_title: "Parcours Entrepreneurial — 7 Étapes",
  programs_7step_subtitle: "De l'Étudiant-Entrepreneur à l'Entrepreneur-Industriel",
  programs_7step_1: "Foi",
  programs_7step_2: "Idée",
  programs_7step_3: "Parcours",
  programs_7step_4: "Outils",
  programs_7step_5: "Modéliser",
  programs_7step_6: "Financer",
  programs_7step_7: "Monétiser",
  programs_ube_title: "Ecoles/Départements UBe",
  programs_ube_1: "Sciences du Bois & Forêt",
  programs_ube_2: "Mines & Industrie (Mécatronique)",
  programs_certifications_title: "Certifications Courtes",
  programs_certifications_desc: "Formations continues de 1 à 3 mois : VAE, alternance, certifications professionnelles. Diplômes reconnus par l'État, co-diplomation nationale et internationale.",

  partnerships_hero_badge: "Réseau Global",
  partners_badge: "Collaboration",
  partnerships_map_badge: "Rayonnement",
  partnerships_future_badge: "Horizons",

  // Admissions Page
  info_future_students: "Futurs Étudiants",
  info_future_students_desc: "Découvrez nos programmes de Licence et Master adaptés aux besoins du marché.",
  info_intl_desc: "Informations pour les étudiants étrangers souhaitant rejoindre ESTAD au Cameroun.",
  scholarships_hero_subtitle_short: "Consultez nos programmes de bourses d'excellence et de mérite pour 2026.",
  admissions_steps_title: "Étapes pour postuler",
  step_research_title: "Recherche de Programme",
  step_research_desc: "Explorez nos 4 piliers d'excellence : Télécoms, Informatique, Communication Numérique et Ingénierie Énergétique. Choisissez le parcours LMD qui vous correspond.",
  step_verify_title: "Vérifier les Conditions",
  step_verify_desc: "Assurez-vous d'avoir votre Baccalauréat ou GCE A/L avec au moins 3 matières (hors Religious Knowledge). Aucune limite d'âge n'est imposée pour favoriser la formation continue.",
  step_submit_title: "Soumettre le Dossier",
  step_submit_desc: "Remplissez le formulaire de pré-inscription en ligne et joignez vos relevés de notes, pièce d'identité et lettre de motivation.",
  step_confirm_title: "Confirmation & Inscription",
  step_confirm_desc: "Après examen de votre dossier (2-3 semaines), vous recevrez une notification de décision. Le paiement des frais d'inscription finalise votre admission.",

  admissions_title: "Admissions",
  admissions_subtitle: "Rejoignez ESTAD et construisez votre avenir",
  admissions_requirements_title: "Conditions d'Admission",
  admissions_requirements_bacc: "Baccalauréat ou équivalent reconnu",
  admissions_requirements_gce: "GCE A/L avec 3 matières (sauf Religious Knowledge)",
  admissions_requirements_age: "Âge : pas de limite (formation tout au long de la vie)",
  admissions_requirements_docs: "Dossier complet : relevés de notes, pièce d'identité, photos, lettre de motivation",
  admissions_requirements_fees: "Frais d'inscription à jour",
  admissions_calendar_title: "Calendrier d'Admission",
  admissions_fees_title: "Frais de Scolarité",
  admissions_fees_note: "Les frais de scolarité varient selon le programme. Contactez-nous pour un devis personnalisé.",
  admissions_entry_title: "Voie d'accès principale",
  admissions_entry_desc: "Baccalauréat ou GCE Advanced Level avec 3 matières (sauf Religious Knowledge). Tout profil motivé est le bienvenu.",
  admissions_cta: "Déposez votre dossier en ligne",
  admissions_brochure: "Télécharger le Livret Étudiant",
  admissions_form_title: "Formulaire de Pré-Inscription",
  admissions_form_name: "Nom complet",
  admissions_form_email: "Adresse e-mail",
  admissions_form_program: "Programme souhaité",
  admissions_form_message: "Message (500 caractères max)",
  admissions_form_submit: "Envoyer ma candidature",
  admissions_faq_title: "Questions Fréquentes",
  admissions_faq_q1: "Quels diplômes délivre ESTAD ?",
  admissions_faq_a1: "ESTAD délivre des diplômes nationaux (DUT, Licence, Master, Doctorat) et des certifications internationales via nos partenaires.",
  admissions_faq_q2: "Puis-je candidater en ligne ?",
  admissions_faq_a2: "Oui, notre plateforme de candidature en ligne est accessible 24/7. Vous pouvez déposer votre dossier et suivre son avancement.",
  admissions_faq_q3: "Est-ce que ESTAD accepte la VAE ?",
  admissions_faq_a3: "Oui, nous proposons la Validation des Acquis de l'Expérience (VAE) pour nos formations continues.",
  admissions_faq_q4: "Quels sont les délais de traitement ?",
  admissions_faq_a4: "Les dossiers sont traités sous 2 à 3 semaines. Une réponse définitive vous est envoyée par e-mail.",
  admissions_faq_q5: "Y a-t-il des bourses disponibles ?",
  admissions_faq_a5: "Oui, des bourses d'excellence et des aides au mérite sont disponibles. Consultez notre bureau des admissions.",
  admissions_faq_q6: "Puis-je étudier à temps partiel ?",
  admissions_faq_a6: "Oui, notre offre de formation continue permet un apprentissage à rythme personnalisé, y compris le soir et le week-end.",

  programs_hero_badge: "Formation d'Excellence",

  programs_7step_badge: "Coaching Entrepreneurial",
  programs_pathway_badge: "Parcours Académique",
  programs_ube_badge: "Université de Bertoua",
  programs_pillar_note: "Les programmes des piliers sont offerts sous l'Université de Douala (UDo), en partenariat avec Polytechnique Douala.",
  programs_journey_from_desc: "Formation, innovation, projets académiques",
  programs_journey_to_desc: "Entreprise, impact, rayonnement international",

  programs_pathway_step_1: "Tronc Commun",
  programs_pathway_step_2: "DUT / BTS",
  programs_pathway_step_3: "Licence",
  programs_pathway_step_4: "Master 1 & 2",
  programs_pathway_step_5: "Doctorat",
  programs_pathway_duration_1: "4 sem",
  programs_pathway_duration_2: "2 ans",
  programs_pathway_duration_3: "2 sem",
  programs_pathway_duration_4: "4 sem",
  programs_pathway_duration_5: "8 sem",

  // Research Page
  research_title: "Recherche & Innovation",
  research_subtitle: "Transformer la recherche en impact concret",
  research_cati_title: "CATI — Centre d'Appui Technologique à l'Innovation",
  research_cati_desc1: "ESTAD abrite l'un des 15 centres CATI de tout le Cameroun, enregistré auprès de l'OMPI (Organisation Mondiale de la Propriété Intellectuelle).",
  research_cati_desc2: "Le CATI offre un accompagnement complet en propriété intellectuelle, des formations certifiées OMPI, et un incubateur pour projets innovants.",
  research_cati_desc3: "Le Cameroun compte plus de 480 institutions d'enseignement supérieur ; ESTAD se distingue parmi les 15 centres CATI nationaux.",
  research_cati_features_ip: "Accompagnement Propriété Intellectuelle",
  research_cati_features_training: "Formations certifiées OMPI",
  research_cati_features_incubation: "Incubation de projets innovants",
  research_raft_title: "RAFT — Research As a Form of Teaching",
  research_raft_desc: "Notre concept de recherche intégrée à l'enseignement place l'étudiant au cœur de la découverte scientifique, transformant chaque cours en opportunité d'innovation.",
  research_partners_title: "Partenaires de Recherche",
  research_partners_crdi: "CRDI Canada",
  research_partners_crdi_date: "",
  research_partners_minmidt: "MINMIDT Cameroun",
  research_partners_minmidt_date: "Novembre 2022",
  research_partners_cbhi: "CBHI",
  research_partners_cbhi_date: "",
  research_partners_esbafim: "ESBAFIM",
  research_partners_esbafim_date: "",
  research_partners_riis: "RIIS",
  research_partners_riis_date: "",
  research_partners_qh: "QH India",
  research_partners_qh_date: "Décembre 2024",
  research_timeline_title: "Chronologie des Réalisations",
  research_timeline_2019: "Fondation du projet ESTAD par MEZOM MELOUTA, ingénieur TICE Promo 94",
  research_timeline_2020: "Fondation d'ESTAD et autorisation MINESUP",
  research_timeline_2021: "Lancement des premiers programmes LMD",
  research_timeline_2022: "Inscription du CATI au programme OMPI",
  research_timeline_2023: "Partenariat avec Polytech Douala et UBe",
  research_timeline_2024: "Première promotion de Master",
  research_timeline_2025: "Expansion internationale — partenariats Asie & Europe",
  research_timeline_2026: "Doctorat en co-tutelle et internationalisation",
  research_dlab_title: "ATF D-LABs — Approche Transdisciplinaire",
  research_dlab_subtitle: "Intègre · Innove · Collabore",
  research_dlab_pipeline_1: "Concept",
  research_dlab_pipeline_2: "Proof",
  research_dlab_pipeline_3: "Technico-économique",
  research_dlab_pipeline_4: "Lancement",
  research_areas_title: "Axes de Recherche",
  research_area_1: "Mécanotransduction",
  research_area_2: "Élastographie (thrombose)",
  research_area_3: "Spectroscopie FTIR",
  research_area_4: "Valorisation coques palmiste/cacao",
  research_area_5: "Fabrication additive",
  research_area_6: "IA & data mining",

  research_hero_badge: "Innovation & Impact",
  research_cati_badge: "CATI Center",
  research_dlab_badge: "Approche Transdisciplinaire",
  research_areas_badge: "Expertise",
  research_timeline_badge: "Chronologie",
  research_partners_badge: "Collaborations",

  // Partnerships Page
  partnerships_title: "Partenariats & Relations Internationales",
  partnerships_subtitle: "Un réseau mondial au service de l'excellence académique",
  partners_title: "Nos Partenaires Institutionnels",
  partner_polytech: "Polytech Douala",
  partner_ube: "Université de Bertoua",
  partner_ompi: "OMPI",
  partner_crdi: "CRDI Canada",
  partner_minmidt: "MINMIDT",
  partner_capef: "CAPEF",
  partner_pacy: "PACY",
  partner_mepmi: "ME/PMI",
  partner_isabe: "ISABE",
  partner_velsoft: "Velsoft Canada",
  partner_beingcert: "BeingCert USA",
  partner_anipes: "ANIPES",
  partnerships_anipes_title: "ESTAD = ANIPES-CENTRE",
  partnerships_anipes_desc: "Représentation Yaoundé 2 — Bureau Diversité, Intersectionnalité et Relations Publiques",
  partnerships_future_title: "Horizons Futurs",
  partnerships_future_1: "Consortium Grands Projets",
  partnerships_future_2: "Modèle PoPs (Proof of Projects)",
  partnerships_future_3: "ATF D-Factory",
  partnerships_dg_quote_text: "ESTAD Vers Vous et Vous vers ESTAD",
  partnerships_dg_quote_author: "MEZOM MELOUTA, DG ESTAD",

  admissions_hero_badge: "Rejoignez ESTAD",
  admissions_req_badge: "Candidature",
  admissions_calendar_open: "Ouverture des candidatures",
  admissions_calendar_open_date: "Janvier 2026",
  admissions_calendar_close: "Clôture des dossiers",
  admissions_calendar_close_date: "30 Juin 2026",
  admissions_calendar_interview: "Entretiens de sélection",
  admissions_calendar_interview_date: "Juillet — Août 2026",
  admissions_calendar_start: "Rentrée académique",
  admissions_calendar_start_date: "Octobre 2026",
  admissions_form_subtitle: "Remplissez le formulaire ci-dessous pour démarrer votre candidature",
  admissions_faq_badge: "FAQ",

  // Campus Page
  campus_title: "Vie de Campus",
  campus_subtitle: "Un environnement d'apprentissage inspirant au cœur de Yaoundé",
  campus_gallery_title: "Galerie Photos",
  campus_associations_title: "Associations Étudiantes",
  campus_association_bedir: "BEDIR — Bureau des Étudiants",
  campus_association_anipes: "ANIPES — Association des Étudiants",
  campus_bilingual_title: "Politique de Bilinguisme",
  campus_bilingual_desc: "ESTAD promeut l'excellence bilingue français-anglais. Tous nos cours, examens et documents administratifs sont disponibles dans les deux langues.",
  campus_bilingual_detail1: "Devoirs et travaux bilingues",
  campus_bilingual_detail2: "Résumés en langue nationale aux soutenances",
  campus_location_title: "Notre Adresse",
  campus_location_address: "Palais des Congrès, Partie Basse, Yaoundé, Cameroun",
  campus_location_desc: "Un emplacement premium, central et accessible, au cœur de la capitale politique du Cameroun.",
  campus_spiritual_title: "Dimension Sociale & Spirituelle",
  campus_spiritual_desc: "Sœur Victorine, Emmanuel et Rachel vous accueillent. Notre campus cultive un environnement bienveillant, inclusif et porteur de valeurs humanistes.",
  campus_welcome_title: "Bienvenue au Campus",
  campus_welcome_text: "Sœur Révérende Victorine, Emmanuel et Rachel vous accueillent.",
  campus_visit_quote: "Palais des Congrès, Partie Basse — absolument à visiter",
  campus_values_title: "Nos Valeurs",
  campus_values_quote: "Ne rien faire pour nuire, tout faire pour construire la paix",

  campus_gallery_subtitle: "Un aperçu de la vie sur le campus ESTAD",

  campus_hero_badge: "Vie Étudiante",
  campus_gallery_badge: "Galerie",

  // Contact Page
  contact_title: "Contactez-Nous",
  contact_subtitle: "Nous sommes à votre écoute. N'hésitez pas à nous contacter.",
  contact_form_name: "Nom complet",
  contact_form_email: "Adresse e-mail",
  contact_form_subject: "Sujet",
  contact_form_program: "Programme d'intérêt",
  contact_form_message: "Votre message (500 caractères max)",
  contact_form_submit: "Envoyer",
  contact_form_success: "Votre message a été envoyé avec succès !",
  contact_form_error: "Une erreur est survenue. Veuillez réessayer.",
  contact_info_address: "Adresse",
  contact_info_address_value: "Palais des Congrès, Partie Basse, Yaoundé, Cameroun",
  contact_info_phone: "Téléphone",
  contact_info_email: "E-mail",
  contact_info_website: "Site web",
  contact_info_website_value: "www.ESTAD-University.com",
  contact_info_phone_value: "(+237) 682 29 12 12 / 696 98 48 48 / 690 02 80 61",
  contact_whatsapp_number: "+237682291212",
  contact_hours_title: "Heures de Bureau",
  contact_hours_value: "Lundi — Vendredi : 8h00 — 17h00",
  contact_social_title: "Suivez-nous",
  contact_whatsapp: "Contactez-nous sur WhatsApp",
  contact_map_title: "Localisation",

  contact_hero_badge: "Contact",
  contact_form_heading: "Envoyez-nous un message",

  // Footer
  footer_tagline: "Inspire, Innovate, For a Better World!",
  footer_quick_links: "Liens Rapides",
  footer_link_home: "Accueil",
  footer_link_about: "À Propos",
  footer_link_programs: "Programmes",
  footer_link_admissions: "Admissions",
  footer_link_research: "Recherche",
  footer_link_contact: "Contact",
  footer_programs: "Nos Programmes",
  footer_prog_telecoms: "Télécoms",
  footer_prog_info: "Informatique",
  footer_prog_comm: "Communication & Arts Numériques",
  footer_prog_energy: "Énergies",
  footer_contact: "Contact",
  footer_contact_address: "Palais des Congrès, Partie Basse",
  footer_contact_city: "Yaoundé, Cameroun",
  footer_contact_phone: "(+237) 682 29 12 12 / 696 98 48 48 / 690 02 80 61",
  footer_contact_email: "secretariat@estad-university.com",
  footer_bottom_copyright: "© ESTAD-University 2026",
  footer_bottom_oapi: "Logo Enregistré OAPI",
  footer_motto: "Foi — Rationalité — Innovation",
  footer_latin_motto: "Crede et quod vis fac — St. Augustin",

  // Common
  common_read_more: "Lire la suite",
  common_learn_more: "En savoir plus",
  common_download: "Télécharger",
  common_send: "Envoyer",
  common_close: "Fermer",
  common_loading: "Chargement...",
  common_required: "Champ requis",
  common_invalid_email: "Adresse e-mail invalide",
  common_max_chars: "Maximum {count} caractères",
  common_all_programs: "Tous les programmes",
  common_program_telecoms: "Télécoms",
  common_program_info: "Informatique",
  common_program_comm: "Communication & Arts Numériques",
  common_program_energy: "Énergies",
  common_select: "Sélectionner...",
  common_year: "Année",
  common_semester: "Semestre",

  presentation_filiere: "Présentation de la Filière",
  tutelle_academique: "Tutelle Académique",
  objectifs_pedagogiques: "Objectifs Pédagogiques",
  programme_modules: "Programme & Modules",
  parcours_academique_lmd: "Parcours Académique LMD",
  debouches_professionnels: "Débouchés Professionnels",
  certifications_associees: "Certifications Associées",
  candidatez_filiere: "Candidatez à la Filière",
  common_apply_now: "Candidater Maintenant",
  common_meet_advisor: "Parler à un Conseiller",
  filiere_precedente: "Filière Précédente",
  filiere_suivante: "Filière Suivante",
  no_programs_found: "Aucun programme trouvé.",
  reset_filters: "Réinitialiser",

  // Program Search
  tab_search_programs: "Recherche de Programme",
  tab_formation_pro: "Formation Professionnelle",
  filter_all: "Tous les programmes",
  filter_bachelor: "Bachelor (Licence)",
  filter_master: "Master Professional",
  filter_doctorate: "Doctorat (Co-tutelle)",
  label_keyword: "Mot-clé",
  label_domain: "Domaine d'Excellence",
  label_campus: "Campus / Niveau",
  btn_rechercher: "Rechercher",
  link_advanced_search: "Options de recherche avancée",

  // Pillars Section
  section_news_pillars: "Actualités et nos piliers",
  programs_7step_title_short: "7 Étapes Entrepreneuriales",
  common_learn_more_short: "En savoir plus",
  link_view_all_projects: "Voir plus de projets et histoires",

  // Programs Page
  label_search_keyword: "Rechercher par mot-clé",
  placeholder_studying: "Qu'est-ce qui vous intéresse ?",
  label_area_interest: "Domaine d'intérêt",
  domain_all_areas: "Tous les domaines",
  label_credential_level: "Niveau de diplôme",
  level_all: "Tous les diplômes",
  btn_search_programs: "Rechercher des programmes",
  showing_count: "Affichage de {{count}} {{label}}",
  sort_by: "Trier par :",
  sort_alphabetical: "Alphabétique",
  sort_credential: "Niveau de diplôme",
  common_details: "Détails",
  cta_not_sure: "Vous ne savez pas quel programme choisir ?",
  cta_advisors_desc: "Nos conseillers académiques sont là pour vous aider à faire correspondre vos passions avec le bon parcours académique.",
  btn_request_info: "Demander des informations",
  btn_meet_advisor: "Rencontrer un conseiller",

  // Philosophy Section
  pillar_foi: "Foi",
  pillar_rationalité: "Rationalité",
  pillar_courage: "Courage",
  pillar_stratégie: "Stratégie",

  // News & Events
  section_news_title: "Dans les actualités",
  section_events_title: "Événements",
  news_inauguration_title: "Inauguration solennelle par le Ministre de l'Enseignement Supérieur",
  news_inauguration_desc: "ESTAD University Institute a été officiellement inaugurée, marquant une nouvelle ère pour l'innovation académique au Cameroun.",
  news_beingcert_title: "Exclusivité BeingCert USA pour 11 pays de la CEMAC",
  news_beingcert_desc: "Un partenariat stratégique exclusif permettant à nos étudiants d'obtenir des certifications internationales en IA et Cybersécurité.",
  event_admissions_open: "Ouverture des Candidatures 2026",
  event_admissions_open_desc: "Début du dépôt des dossiers pour les nouveaux bacheliers et professionnels.",
  event_admissions_close: "Clôture des Dossiers d'Admission",
  event_admissions_close_desc: "Date limite impérative pour les programmes de Bachelor et Master.",
  event_academic_start: "Rentrée Académique 2026-2027",
  event_academic_start_desc: "Cérémonie solennelle de rentrée au Palais des Congrès.",

  // Info Section
  hero_card_intro_student: "Rejoignez notre communauté dynamique et commencez votre parcours vers l'excellence dès aujourd'hui. Candidatures ouvertes pour la session 2026.",
  info_for_title: "Informations pour :",
  info_international_students: "Étudiants Internationaux",
  info_partners_industry: "Partenaires & Entreprises",

  // Sidebar
  sidebar_resources_title: "Ressources Utiles",
  sidebar_resources_label: "Ressources",
  sidebar_help_title: "Besoin d'aide ?",
  sidebar_help_desc: "Notre bureau des admissions est disponible pour vous accompagner dans votre projet professionnel.",
  sidebar_apply_title: "Prêt à postuler ?",
  sidebar_apply_desc: "Rejoignez notre prochaine promotion. Les admissions ouvrent en Janvier 2026.",
  link_vision_more: "En savoir plus sur notre vision",
  admissions_calendar_open_note: "Candidatures en ligne",
  admissions_calendar_close_note: "Clôture des dossiers",
  admissions_calendar_start_note: "Inauguration académique",
  why_card_innovation_desc_short: "Enregistrement officiel du Centre CATI OMPI pour le support PI.",
  research_raft_title_short: "Approche RAFT : La Recherche comme Forme d'Enseignement.",

  // Quick Links Section
  calendar_desc_short: "Dates importantes pour les admissions, les formations du collège et les jours fériés.",
  explore_campus_title: "Explorer le Campus",
  explore_campus_desc_short: "Découvrez nos installations modernes situées au cœur de la capitale politique.",
  link_view_calendar: "Voir le calendrier",
  link_virtual_tour: "Visite virtuelle",

  // News Page
  news_page_title: "Actualités & Événements",
  news_page_subtitle: "Restez informé des dernières nouvelles, événements et opportunités à l'ESTAD",
  news_back_to_list: "Retour aux actualités",
  news_related: "Articles similaires",
  news_share: "Partager cet article",
  news_subscribe_title: "Ne manquez aucune actualité",
  news_subscribe_desc: "Inscrivez-vous à notre newsletter pour recevoir les dernières informations sur les événements, les formations et les opportunités",
  news_subscribe_cta: "S'inscrire à la newsletter",

  // Partner Types
  partner_polytech_type: "Partenaire Académique",
  partner_ube_type: "Université Partenaire",
  partner_ompi_type: "Organisation Internationale",
  partner_crdi_type: "Centre de Recherche",
  partner_minmidt_type: "Ministère",
  partner_capef_type: "Institution Financière",
  partner_pacy_type: "Association",
  partner_mepmi_type: "Institution Publique",
  partner_isabe_type: "École Partenaire",
  partner_velsoft_type: "Partenaire Technologique",
  partner_beingcert_type: "Certification",
  partner_anipes_type: "Centre d'Innovation",

  // Research Page - CATI Features
  research_cati_feature_ip: "Protection de la Propriété Intellectuelle",
  research_cati_feature_training: "Formation & Certification",
  research_cati_feature_incubation: "Incubation de Startups",
  research_cati_feature_patents: "Dépôt de Brevets",
  research_cati_feature_techtransfer: "Transfert de Technologie",

  // Research Page - Timeline Details
  research_milestone_2019_title: "Fondation du CATI",
  research_milestone_2019_desc: "Enregistrement du Centre Africain de Technologie et d'Innovation auprès de l'OMPI",
  research_milestone_2020_title: "Lancement RAFT",
  research_milestone_2020_desc: "Introduction de la méthodologie Research Accelerated Fast Track",
  research_milestone_2021_title: "Premiers brevets",
  research_milestone_2021_desc: "Dépôt des premières demandes de brevets par des étudiants ESTAD",
  research_milestone_2022_title: "Partenariat QH India",
  research_milestone_2022_desc: "Collaboration internationale en recherche quantique",
  research_milestone_2023_title: "Lab D-Labs",
  research_milestone_2023_desc: "Ouverture des laboratoires décentralisés de recherche",
  research_milestone_2024_title: "Excellence OAPI",
  research_milestone_2024_desc: "Reconnaissance comme centre d'excellence en propriété intellectuelle",
  research_milestone_2025_title: "Expansion",
  research_milestone_2025_desc: "Ouverture de 3 nouveaux laboratoires spécialisés",
  research_milestone_2026_title: "Vision 2030",
  research_milestone_2026_desc: "Lancement du programme de recherche décennal",

  // Partnerships Map Section
  partnerships_map_title: "Notre Réseau de Partenaires",

  // Research Areas 7 & 8
  research_area_7: "Énergies Renouvelables",
  research_area_8: "IoT & Réseaux",

  // Research CATI Features - Plural form
  research_cati_features_patents: "Dépôt de Brevets",
  research_cati_features_techtransfer: "Transfert de Technologie",

  // Partnerships - Additional translations
  partnerships_benefits_badge: "Avantages",
  partnerships_benefits_title: "Pourquoi s'associer avec ESTAD ?",
  partnerships_benefits_desc: "Nos partenariats créent de la valeur par l'excellence académique, l'intégration professionnelle et les opportunités internationales.",
  partnerships_collab_badge: "Collaboration",
  partnerships_collab_title: "Types de Partenariat",
  partnerships_collab_desc: "ESTAD s'engage avec des partenaires dans plusieurs domaines pour créer une valeur complète pour les étudiants et les institutions.",
  partnerships_network_badge: "Réseau",
  partnerships_network_title: "Nos Institutions Partenaires",
  partnerships_network_desc: "Découvrez les organisations qui rendent possible l'excellence d'ESTAD grâce à une collaboration stratégique.",
  partnerships_key_benefits: "Avantages Clés",
  partnerships_location: "Cameroun — Yaoundé",
  partnerships_global_reach: "Europe — Canada — Inde — Asie",
  partnerships_gallery_badge: "Galerie",
  partnerships_gallery_title: "Partenariats en Action",
  partnerships_gallery_desc: "Moments forts de nos initiatives collaboratives et événements",

  // Partnership Benefits
  partnerships_benefit_academic_title: "Excellence Académique",
  partnerships_benefit_academic_desc: "Accès à des programmes internationalement reconnus avec opportunités de doubles diplômes et co-supervision académique.",
  partnerships_benefit_professional_title: "Intégration Professionnelle",
  partnerships_benefit_professional_desc: "Voies d'accès direct à l'emploi grâce aux partenariats d'entreprises, stages et accompagnement entrepreneurial.",
  partnerships_benefit_mobility_title: "Mobilité Internationale",
  partnerships_benefit_mobility_desc: "Programmes d'échanges, opportunités d'études à l'étranger et collaborations de recherche mondiales sur 4 continents.",
  partnerships_benefit_research_title: "Innovation & Recherche",
  partnerships_benefit_research_desc: "Accès au centre CATI-WIPO, support de dépôt de brevets et laboratoires de recherche de pointe.",
  partnerships_benefit_certified_title: "Formation Certifiante",
  partnerships_benefit_certified_desc: "Certifications internationales incluant l'exclusivité BeingCert pour l'IA et la Cybersécurité dans la CEMAC.",
  partnerships_benefit_network_title: "Réseau & Communauté",
  partnerships_benefit_network_desc: "Rejoignez un réseau mondial d'étudiants, chercheurs et professionnels au Cameroun et à l'international.",

  // Collaboration Types
  partnerships_collab_academic_title: "Partenariats Académiques",
  partnerships_collab_academic_desc: "Doubles diplômes, thèses co-encadrées, échanges étudiants et programmes de recherche conjoints avec des universités de premier plan.",
  partnerships_collab_research_title: "Recherche & Innovation",
  partnerships_collab_research_desc: "Collaboration sur des projets de recherche appliquée, transfert de technologie et protection de la propriété intellectuelle.",
  partnerships_collab_professional_title: "Intégration Professionnelle",
  partnerships_collab_professional_desc: "Stages, apprentissages et voies d'emploi direct avec des partenaires d'entreprises.",
  partnerships_collab_tech_title: "Technologie & Certification",
  partnerships_collab_tech_desc: "Accès à la technologie éducative de pointe et aux programmes de certification internationale.",

  // Partner Descriptions
  partner_polytech_desc: "Ecole Polytechnique de Douala — Premier établissement d'enseignement supérieur technique du Cameroun, offrant une supervision académique de excellence pour les programmes d'ingénierie.",
  partner_ube_desc: "Université publique du Cameroun spécialisée dans les sciences forestières, minières et industrielles. Partenaire privilégié pour les programmes de Master et Doctorat.",
  partner_ompi_desc: "Organisation Africaine de la Propriété Intellectuelle et World Intellectual Property Organization. Partenaire stratégique pour la protection de la propriété intellectuelle.",
  partner_crdi_desc: "Centre de Recherches pour le Développement International — Organisation canadienne de financement de la recherche scientifique dans les pays en développement.",
  partner_minmidt_desc: "Ministère des Mines, de l'Industrie et du Développement Technologique du Cameroun. Partenaire gouvernemental pour l'innovation industrielle.",
  partner_capef_desc: "Caisse des Dépôts et Consignations — Institution financière camerounaise soutenant le développement économique et l'entrepreneuriat.",
  partner_pacy_desc: "Partenaire académique et institutionnel camerounais engagé dans le développement de la jeunesse et de l'éducation.",
  partner_mepmi_desc: "Ministère des Petites et Moyennes Entreprises — Partenaire pour l'accompagnement entrepreneurial et l'insertion professionnelle des étudiants.",
  partner_isabe_desc: "Institut Supérieur des Affaires et du Business Européen — Partenaire européen pour les programmes internationaux et la mobilité académique.",
  partner_velsoft_desc: "Éditeur canadien de solutions pédagogiques et de contenus de formation — Partenaire pour les ressources éducatives numériques.",
  partner_beingcert_desc: "Organisme de certification international américain. ESTAD détient l'exclusivité BeingCert pour 11 pays de la CEMAC en Intelligence Artificielle et Cybersécurité.",
  partner_anipes_desc: "Association pour la Diversité, l'Intersectionnalité et les Relations Publiques — Bureau de représentation Yaoundé 2, centre d'innovation et d'inclusion.",

  // Partner Benefits
  partner_benefit_academic: "Supervision académique",
  partner_benefit_diploma: "Reconnaissance des diplômes",
  partner_benefit_resources: "Accès aux ressources scientifiques",
  partner_benefit_cotutelle: "Co-tutelle de thèses",
  partner_benefit_joint: "Programmes conjoints",
  partner_benefit_mobility: "Mobilité étudiante",
  partner_benefit_patents: "Enregistrement des brevets",
  partner_benefit_training: "Formation WIPO",
  partner_benefit_ip: "Protection PI",
  partner_benefit_funding: "Financement recherche",
  partner_benefit_intl: "Partenariats internationaux",
  partner_benefit_publication: "Publication scientifique",
  partner_benefit_institutional: "Appui institutionnel",
  partner_benefit_industrial: "Projets industriels",
  partner_benefit_tech: "Innovation technologique",
  partner_benefit_financing: "Financement projets",
  partner_benefit_coaching: "Accompagnement entrepreneurial",
  partner_benefit_credit: "Accès au crédit",
  partner_benefit_network: "Réseau professionnel",
  partner_benefit_internship: "Opportunités de stage",
  partner_benefit_personal: "Développement personnel",
  partner_benefit_startup: "Création d'entreprise",
  partner_benefit_sme: "Accompagnement PME",
  partner_benefit_entrepreneur: "Réseau entrepreneur",
  partner_benefit_dual: "Double diplôme",
  partner_benefit_europe: "Mobilité Europe",
  partner_benefit_global: "Réseau international",
  partner_benefit_pedagogical: "Contenus pédagogiques",
  partner_benefit_elearning: "Formation e-learning",
  partner_benefit_educational: "Ressources éducatives",
  partner_benefit_certifications: "Certifications internationales",
  partner_benefit_cemac: "Exclusivité CEMAC",
  partner_benefit_ai: "IA & Cybersécurité",
  partner_benefit_inclusion: "Inclusion",
  partner_benefit_diversity: "Diversité",
  partner_benefit_pr: "Relations publiques",

  // Partner Categories
  partners_categories_badge: "Nos Partenaires",
  partners_categories_title: "Un Réseau d'Excellence",
  partners_categories_desc: "ESTAD collabore avec des institutions prestigieuses pour offrir une formation d'exception et des opportunités uniques à ses étudiants.",

  partners_category_institutional_title: "Partenaires Institutionnels",
  partners_category_institutional_subtitle: "Institutionnel",
  partners_category_academic_title: "Tutelle Académique",
  partners_category_academic_subtitle: "Académique",
  partners_category_private_title: "Partenaires Privés",
  partners_category_private_subtitle: "Privé",
  partners_category_anipes_title: "Partenaires de l'ANIPES",
  partners_category_anipes_subtitle: "ANIPES",

  // Additional Partner Short Descriptions
  partner_minmidt_short_desc: "Ministère des Mines, de l'Industrie et du Développement Technologique",
  partner_palais_congres_desc: "Palais des Congrès de Yaoundé — Hébergement d'ESTAD",
  partner_mepmi_short_desc: "Ministère des Petites et Moyennes Entreprises",
  partner_capef_short_desc: "Caisse des Dépôts et Consignations — Appui financier",

  // Academic Partners Descriptions
  partner_ud_desc: "Université de Douala — Partenaire académique majeur",
  partner_estmre_desc: "École Supérieure des Mines et des Ressources Énergétiques",
  partner_isabee_desc: "Institut Supérieur d'Agriculture, du Bois, de l'Eau et de l'Environnement",

  // Research Partners
  partner_riis_desc: "Research Institute for Innovation and Science",
  partner_qh_desc: "QH India — Partenaire recherche quantique",

  // Why ESTAD Page
  why_hero_badge: "Pourquoi Nous Choisir",
  why_hero_title: "L'Excellence au Cœur de l'Innovation",
  why_hero_subtitle: "ESTAD combine excellence académique, innovation technologique et entrepreneuriat pour former les leaders de demain.",
  why_reasons_badge: "Nos Atouts",
  why_reasons_title: "Ce Qui Nous Différencie",
  why_card_excellence_title: "Excellence Académique",
  why_card_excellence_desc: "Programmes certifiés et reconnus internationalement avec un corps professoral d'exception.",
  why_stat_programs: "Programmes disponibles",
  why_card_international_title: "Rayonnement International",
  why_card_international_desc: "Partenariats avec des institutions prestigieuses à travers le monde pour une ouverture maximale.",
  why_stat_partners: "Partenaires internationaux",
  why_stat_steps: "Étapes du parcours",
  why_stat_cati: "centre CATI au Cameroun",
  why_diff_badge: "Notre Différence",
  why_diff_title: "Une Approche Unique",
  why_diff_subtitle: "ESTAD innove par sa pédagogie, ses partenariats et son environnement d'apprentissage exceptionnel.",
  why_diff_digital_title: "Pédagogie Digitale",
  why_diff_digital_desc: "Technologies avancées et plateformes e-learning pour un apprentissage moderne.",
  why_diff_dual_title: "Double Diplôme",
  why_diff_dual_desc: "Possibilité d'obtenir des certifications nationales et internationales.",
  why_diff_location_title: "Emplacement Prestigieux",
  why_diff_location_desc: "Campus au Palais des Congrès de Yaoundé, accessible et sécurisé.",
  why_diff_cert_title: "Certifications Reconnues",
  why_diff_cert_desc: "Diplômes et certifications valorisés par les employeurs du monde entier.",
  why_cta_title: "Prêt à Rejoindre l'Excellence ?",
  why_cta_subtitle: "Découvrez nos programmes et commencez votre parcours vers l'excellence académique et professionnelle.",
  why_cta_programs: "Explorer les Programmes",
  why_cta_apply: "Postuler Maintenant",

  // Bachelor Page
  bachelor_title: "Licence",
  bachelor_hero_title: "Programmes de Licence",
  bachelor_hero_subtitle: "Des formations complètes de 3 ans (180 crédits) préparant les étudiants aux métiers de demain dans les domaines des technologies et de l'innovation.",
  bachelor_programs_badge: "Nos Licences",
  bachelor_programs_title: "Choisissez Votre Filière",
  bachelor_telecoms_title: "Télécommunications",
  bachelor_telecoms_desc: "Formation complète en ingénierie des télécommunications, réseaux mobiles, fibre optique et systèmes embarqués.",
  bachelor_informatique_title: "Informatique",
  bachelor_informatique_desc: "Développement logiciel, intelligence artificielle, cybersécurité et data science.",
  bachelor_communication_title: "Communication Numérique",
  bachelor_communication_desc: "Médias digitaux, design interactif, production audiovisuelle et marketing digital.",
  bachelor_energy_title: "Énergies Renouvelables",
  bachelor_energy_desc: "Ingénierie énergétique, énergies renouvelables, smart grids et transition énergétique.",
  bachelor_highlights_badge: "Points Forts",
  bachelor_highlights_title: "Pourquoi Choisir Nos Licences",
  bachelor_cta_title: "Prêt à Commencer Votre Parcours ?",
  bachelor_cta_apply: "Postuler Maintenant",
  bachelor_cta_contact: "Rencontrer un Conseiller",

  // Master Page
  master_title: "Master",
  master_hero_title: "Programmes de Master",
  master_hero_subtitle: "Des formations avancées de 2 ans (120 crédits) pour les professionnels souhaitant approfondir leur expertise et développer des compétences en recherche.",
  master_programs_badge: "Nos Masters",
  master_programs_title: "Spécialisez-Vous",
  master_telecoms_title: "Master Télécommunications",
  master_telecoms_desc: "Expertise avancée en réseaux 5G/6G, IoT, cloud computing et architecture télécoms.",
  master_informatique_title: "Master Informatique",
  master_informatique_desc: "Développement avancé, architecture logicielle, DevOps et gestion de projets IT.",
  master_data_science_title: "Master Data Science",
  master_data_science_desc: "Machine learning, deep learning, big data analytics et intelligence artificielle.",
  master_cybersecurity_title: "Master Cybersécurité",
  master_cybersecurity_desc: "Sécurité offensive et défensive, forensic, gouvernance et conformité.",
  master_highlights_badge: "Points Forts",
  master_highlights_title: "Pourquoi Choisir Nos Masters",
  master_cta_title: "Prêt à Passer au Niveau Supérieur ?",
  master_cta_apply: "Postuler au Master",
  master_cta_contact: "Rencontrer un Conseiller",

  // Scholarships Page
  scholarships_hero_badge: "Financement des Études",
  scholarships_hero_title: "Bourses et Aide Financière",
  scholarships_hero_subtitle: "ESTAD s'engage à rendre l'excellence éducative accessible. Découvrez nos programmes de bourses et d'aide financière.",
  scholarship_stat_budget: "Budget annuel",
  scholarship_stat_recipients: "Boursiers",
  scholarship_stat_types: "Types de bourses",
  scholarship_stat_coverage: "Taux de couverture max",
  scholarship_types_badge: "Types de Bourses",
  scholarship_types_title: "Trouvez la Bourse Qui Vous Correspond",
  scholarship_excellence_title: "Bourse d'Excellence",
  scholarship_excellence_desc: "Pour les étudiants aux résultats académiques exceptionnels. Couvre jusqu'à 100% des frais de scolarité.",
  scholarship_excellence_criteria_1: "Moyenne générale ≥ 16/20",
  scholarship_excellence_criteria_2: "Excellent dossier académique",
  scholarship_excellence_criteria_3: "Lettres de recommandation",
  scholarship_merit_title: "Bourse au Mérite",
  scholarship_merit_desc: "Reconnait les talents et l'engagement des étudiants dans la vie universitaire.",
  scholarship_merit_criteria_1: "Moyenne générale ≥ 14/20",
  scholarship_merit_criteria_2: "Participation aux activités ESTAD",
  scholarship_merit_criteria_3: "Projet entrepreneurial viable",
  scholarship_need_title: "Bourse Sociale",
  scholarship_need_desc: "Soutient les étudiants ayant des besoins financiers démontrés.",
  scholarship_need_criteria_1: "Justificatifs de revenus",
  scholarship_need_criteria_2: "Lettre de motivation détaillée",
  scholarship_need_criteria_3: "Entretien avec le comité",
  scholarship_intl_title: "Bourse Internationale",
  scholarship_intl_desc: "Destinée aux étudiants étrangers souhaitant étudier à ESTAD.",
  scholarship_intl_criteria_1: "Statut d'étudiant étranger",
  scholarship_intl_criteria_2: "Niveau de français B2 minimum",
  scholarship_intl_criteria_3: "Engagement de retour au pays d'origine",
  scholarship_criteria: "Critères",
  scholarship_process_badge: "Processus",
  scholarship_process_title: "Comment Postuler",
  scholarship_step_1_title: "Vérifier l'éligibilité",
  scholarship_step_1_desc: "Consultez les critères de chaque bourse et vérifiez votre éligibilité.",
  scholarship_step_2_title: "Préparer le dossier",
  scholarship_step_2_desc: "Rassemblez les documents requis : relevés de notes, lettres, justificatifs.",
  scholarship_step_3_title: "Entretien",
  scholarship_step_3_desc: "Si présélectionné, participez à un entretien avec le comité des bourses.",
  scholarship_step_4_title: "Décision",
  scholarship_step_4_desc: "Recevez la notification de décision par email dans les 2 semaines suivant l'entretien.",
  scholarship_faq_badge: "FAQ",
  scholarship_faq_title: "Questions Fréquentes",
  scholarship_faq_1_q: "Quand puis-je postuler pour une bourse ?",
  scholarship_faq_1_a: "Les candidatures ouvrent en même temps que les inscriptions, généralement en janvier de chaque année académique.",
  scholarship_faq_2_q: "Puis-je cumuler plusieurs bourses ?",
  scholarship_faq_2_a: "Non, chaque étudiant ne peut bénéficier que d'une seule bourse à la fois. Le montant le plus avantageux est retenu.",
  scholarship_faq_3_q: "Les bourses sont-elles renouvelables ?",
  scholarship_faq_3_a: "Oui, sous réserve de maintenir une moyenne minimale de 12/20 et de respecter le règlement intérieur.",
  scholarship_faq_4_q: "Comment se déroule l'entretien de sélection ?",
  scholarship_faq_4_a: "L'entretien dure environ 30 minutes et porte sur votre parcours, vos motivations et votre projet professionnel.",
  scholarship_cta_title: "Postulez dès Maintenant",
  scholarship_cta_subtitle: "Les bourses sont attribuées sur la base du mérite et des besoins. Ne manquez pas les dates limites.",
  scholarship_cta_apply: "Postuler en Ligne",
  scholarship_cta_contact: "Contacter le Bureau des Bourses",

  // Supervisor Institutions
  about_supervisors_subtitle: "ESTAD bénéficie de la tutelle académique et scientifique de cinq institutions d'excellence",
  supervisor_ud: "Université de Douala",
  supervisor_ud_desc: "Université publique de référence au Cameroun",
  supervisor_ube: "Université de Bertoua",
  supervisor_ube_desc: "Université publique — Sciences forestières et industrielles",
  supervisor_enspd: "École Nationale Supérieure Polytechnique de Douala",
  supervisor_enspd_desc: "Premier établissement d'enseignement supérieur technique",
  supervisor_estmre: "École Supérieure des Mines et des Ressources Énergétiques",
  supervisor_estmre_desc: "Excellence en ingénierie des mines et énergies",
  supervisor_isabee: "Institut Supérieur d'Agriculture, du Bois, de l'Eau et de l'Environnement",
  supervisor_isabee_desc: "Formation en sciences agronomiques et environnementales",
};